import { createServiceAction } from '../util/actionHelper.js';
import { apiConfig } from '../configs/apiConfig.js';
import { putRequest, displayMessage } from '../util/index.js';
import { getHTTPStatusValidationMessage, getServerValidationMessage } from '../services/serverValidations.js';

import { put, takeEvery, call } from 'redux-saga/effects';

function* listener(serviceType, action) {
    try {
        yield put(createServiceAction(serviceType, 'loading')());
        const infoPopDuration = 1000;
        const res = yield call(putRequest, apiConfig.dashboardArcStatus.endPointUrl, action.data);
        // Display HTTP status error message
        const statusErrorMessage = yield call(getHTTPStatusValidationMessage, res);
        if (!statusErrorMessage) {
            const response = yield res.json();
            // Display server error message
            const serverErrorMessage = yield call(getServerValidationMessage, response, infoPopDuration);
            if (!serverErrorMessage && response.errorCode === 0) {
                yield put(createServiceAction(serviceType, 'success')(response));
                const message = `${response.message}`;
                // Display success message
                yield call(displayMessage, 'success', message, 5000);
                yield put( createServiceAction('testSummary', 'requested')({ isClearHistory: false, status: action.data.buttonStatus, supplierName:  action.data.supplierName, fromDate:  action.data.fromDate }))
                yield put( createServiceAction('testSummaryCount', 'requested')({ isClearHistory: false, status: action.data.buttonStatus, supplierName:  action.data.supplierName, fromDate:  action.data.fromDate }))
            }
        } 
    } catch (e) {
        yield put(createServiceAction(serviceType, 'error')(e));
    }
}

function* dashboardArchivedStatus() {
    const serviceType = 'dashboardArcStatus';
    yield takeEvery(createServiceAction(serviceType, 'submitted').type, listener, serviceType);
}

export default dashboardArchivedStatus;